import { render, staticRenderFns } from "./HumanCapitalTurnoverReport.vue?vue&type=template&id=269fa2e6&scoped=true&"
import script from "./HumanCapitalTurnoverReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalTurnoverReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalTurnoverReport.vue?vue&type=style&index=0&id=269fa2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269fa2e6",
  null
  
)

export default component.exports